module.exports = __webpack_public_path__ + "static/media/image-sunday.9d92a3aa.jpg";